module.exports = __webpack_public_path__ + "media/images/black_history_month/bg-shape-green-0b169942da7c12540988be5aa9ed49df.svg";